"use client"

import React, { FC } from "react"
import {
  Channel as ChannelComponent,
  Window,
  Chat,
  MessageInput,
  MessageList,
  Thread,
  defaultRenderMessages,
  MessageRenderer,
} from "stream-chat-react"
import { ThreadHeader } from "../ThreadHeader"
import { fileUploadIcon, sendButton } from "../MesssagesMainContent"
import { TypingIndicator } from "../TypingIndicator"
import { MessagingChannelHeader } from "../MessagingChannelHeader"
import { MessageModalLoading } from "./MessageModalLoading"
import { Channel, StreamChat } from "stream-chat"
import { ampli } from "@/ampli"
import { ChatWarningText } from "../ChatWarningText"
import { StreamChatGenerics } from "../types"
import { decodeGraphqlNodeId } from "@/tracking"
import { useSession } from "@/hooks/useSession"

interface Props {
  client: StreamChat<any>
  channel: Channel | null
}

const actions = ["delete", "edit", "flag", "markUnread", "mute", "react", "reply"]

export const MessageModalChannel: FC<Props> = ({ client, channel }) => {
  const session = useSession()

  const sessionUuid = session?.data?.user?.uuid

  if (!client || !channel) {
    return <MessageModalLoading />
  }

  const members = Object.values(channel.state.members || {}).filter(member => member.user?.id !== sessionUuid)

  const handleOverrideSubmit = async (message: any, channelCid: string) => {
    ampli.chatMessageSend({
      chat_type: channel.type,
      user_id: members.map(member => decodeGraphqlNodeId(member?.user?.relay_id as string).numericalId || ""),
    })

    await channel.sendMessage(message)
  }

  const customRenderMessages: MessageRenderer = options => {
    const elements = defaultRenderMessages(options)
    elements.unshift(<ChatWarningText />)
    return elements
  }

  return (
    <Chat client={client}>
      <div className="h-full flex-1">
        <ChannelComponent
          channel={channel}
          ThreadHead={ThreadHeader}
          maxNumberOfFiles={10}
          multipleUploads={true}
          FileUploadIcon={fileUploadIcon}
          SendButton={sendButton}
          TypingIndicator={TypingIndicator}
          enrichURLForPreview>
          <div className="relative flex flex-1 flex-shrink-0 flex-col">
            <MessagingChannelHeader showChannelOptions={false} showMobileBackButton={false} />
            <div className="flex h-full flex-1 flex-col items-center overflow-y-auto overflow-x-hidden">
              <Window>
                <MessageList messageActions={actions} renderMessages={customRenderMessages} />
                <MessageInput
                  audioRecordingEnabled
                  asyncMessagesMultiSendEnabled
                  overrideSubmitHandler={handleOverrideSubmit}
                />
              </Window>
            </div>

            <Thread />
          </div>
        </ChannelComponent>
      </div>
    </Chat>
  )
}
